import React, {useCallback, useState} from 'react';
import {Select, SelectProps} from '@innowise-group/ui-kit';
import {useTranslation} from 'react-i18next';
import {useGetEmployees} from './use-get-employees.hook';

const EmployeesSelect: React.FC<SelectProps> = (props) => {
  const [employeeName, setEmployeeName] = useState('');
  const {employees, isLoading, valueTransform} = useGetEmployees(employeeName);

  const {t} = useTranslation();

  const handleSearchChange = useCallback((value: string) => {
    setEmployeeName(value);
  }, []);

  return (
    <Select
      {...props}
      onChangeSearchValue={handleSearchChange}
      asyncValueTransformer={valueTransform}
      options={employees}
      onNoValueFoundText={isLoading ? t('modals.loading') : t('modals.noFoundEmployee')}
      clearable
    />
  );
};

export default React.memo(EmployeesSelect);
